import React, { Component } from 'react'
import PresetFiltersComponent from './PresetFilters.component'

class PresetFiltersContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      quickFilters: props.quickFilters,
      appliedSavedFilter: props.api.getCustomFilterId()
    }
  }

  /**
   * @description - helper function to coerce date string fragments from server into suitable date object
   * @param {*} str
   */
  formatQuickDate(str) {
    return str.substr(0, 4) + '-' + str.substr(4, 2) + '-' + str.substr(6) + 'T00:00:00.000Z'
  }

  // This converts data from the backend to the internal format
  getProcessedFiltersToApply = (filterObj, filterId, filterName) => {
    const applyFilters = filterObj.map((filterItemRaw) => {
      const filterItem = Object.assign({}, filterItemRaw)

      if (filterItem.type === 'list' || filterItem.type === 'select' || filterItem.type === 'treeView') {
        if (typeof filterItem.values === 'string' && filterItem.values.indexOf(';') > -1) {
          const rawValues = filterItem.values.split(';')

          const obj = rawValues.map((item) => {
            return {
              label: item,
              value: item
            }
          })

          filterItem.values = obj
        }
      }

      if (filterItem.type === 'daterange') {
        if (typeof filterItem.values === 'string' && filterItem.values.indexOf(';') > -1) {
          const rawValues = filterItem.values.split(';')

          const obj = {
            startDate: new Date(this.formatQuickDate(rawValues[0])),
            endDate: new Date(this.formatQuickDate(rawValues[1]))
          }

          filterItem.values = obj
        } else if (filterItem.values.startDate && filterItem.values.endDate) {
            const obj = {
              startDate: new Date(filterItem.values.startDate),
              endDate: new Date(filterItem.values.endDate)
            }

            filterItem.values = obj
          }
      }

      if (filterItem.type === 'datesingle') {
        if (filterItem.values !== null && typeof filterItem.values === 'string') {
          const rawValues = filterItem.values

          filterItem.values = new Date(this.formatQuickDate(rawValues))
        }
      }

      if (filterItem.type === 'dateselector') {
        if (filterItem.values !== null && typeof filterItem.values === 'string') {
          let rawValues = []
          let obj = {}

          if (filterItem.values.indexOf(';') > -1) {
            rawValues = filterItem.values.split(';')
            if (rawValues[0] === 'datesingle') {
              if (rawValues[1] === 'today') {
                obj = {
                  dateType: 'dateSingle',
                  selectedId: 'today'
                }
              } else {
                obj = {
                  dateType: 'dateSingle',
                  selectedId: 'dateSingle',
                  date: new Date(this.formatQuickDate(rawValues[1]))
                }
              }
            } else if (rawValues[0] === 'daterange') {
              if (rawValues[1] === '7') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: '7'
                }
              } else if (rawValues[1] === '30') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: '30'
                }
              } else if (rawValues[1] === 'week') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: 'week'
                }
              } else if (rawValues[1] === 'month') {
                obj = {
                  dateType: 'dateRange',
                  selectedId: 'month'
                }
              } else {
                obj = {
                  dateType: 'dateRange',
                  selectedId: 'dateRange',
                  startDate: new Date(this.formatQuickDate(rawValues[1])),
                  endDate: new Date(this.formatQuickDate(rawValues[2]))
                }
              }
            } else {
              obj = {
                dateType: 'dateRange',
                selectedId: 'dateRange',
                startDate: new Date(this.formatQuickDate(rawValues[0])),
                endDate: new Date(this.formatQuickDate(rawValues[1]))
              }
            }
          } else {
            obj = {
              dateType: 'dateSingle',
              selectedId: 'dateSingle',
              date: new Date(this.formatQuickDate(filterItem.values))
            }
          }
          filterItem.values = obj
        } else if (filterItem.values !== null && typeof filterItem.values === 'object') {
          let obj = {}

          if (filterItem.values.dateType === 'dateSingle' || filterItem.values.dateType === 'datesingle') {
            obj = {
              dateType: 'dateSingle',
              selectedId: filterItem.values.selectedId,
              date: new Date(filterItem.values.date)
            }
          } else if (filterItem.values.dateType === 'dateRange' || filterItem.values.dateType === 'dateRange') {
            obj = {
              dateType: 'dateRange',
              selectedId: filterItem.values.selectedId,
              startDate: new Date(filterItem.values.startDate),
              endDate: new Date(filterItem.values.endDate)
            }
          }
          filterItem.values = obj
        }
      }

      const yieldFilterItem = (filterType) => {
        if (filterType === 'list') {
          return 'select'
        }
        if (filterType === 'daterange') {
          return 'daterange'
        }
        if (filterType === 'datesingle') {
          return 'datesingle'
        }
        if (filterType === 'dateselector') {
          return 'dateselector'
        }
        if (filterType === 'search') {
          return 'text'
        }
        else{
          return filterType
        }
      }

      filterItem.handle = 'bodyfilter_' + yieldFilterItem(filterItem.type) + '_' + filterItem.column

      return filterItem
    })

    return applyFilters
  }

  handleQuickFilterApply = (filterObj, filterId, filterName) => {
    const applyFilters = this.getProcessedFiltersToApply(filterObj, filterId, filterName)

    this.props.setAllFilters(applyFilters)
    this.props.api.setCustomFilter(filterName)
    this.props.api.setCustomFilterId(filterId)
    this.props.api.setCustomFilterType('quick')
    this.setState({
      appliedSavedFilter: filterId
    })
  }

  handleSavedFilterApply = (filterObj, filterId, filterName) => {
    const applyFilters = this.getProcessedFiltersToApply(filterObj, filterId, filterName)

    this.props.setAllFilters(applyFilters)
    this.props.api.setCustomFilter(filterName)
    this.props.api.setCustomFilterId(filterId)
    this.props.api.setCustomFilterType('saved')
    this.setState({
      appliedSavedFilter: filterId
    })
  }

  handleSavedFilterRemove = (filterID) => {
    this.props.handleRemove(filterID)
    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)
  }

  getApplied() {
    let output = null

    // debugger
    /**
     * this content needs to be promoted to a higher level state.
     * We need to be able to restore the appliedSavedFilter when the drawer is reopened
     * should it go into API?
     */

    if (this.state.appliedSavedFilter && this.props.api.getCustomFilter()) {
      output = this.state.appliedSavedFilter
    }

    return output
  }

  render() {
    const { quickFilters } = this.state
    const { savedFilters, analytics } = this.props

    const events = {
      handleQuickFilterApply: this.handleQuickFilterApply,
      handleSavedFilterApply: this.handleSavedFilterApply,
      handleSavedFilterRemove: this.handleSavedFilterRemove
    }

    const applied = this.getApplied()

    return ((savedFilters && savedFilters.filters && savedFilters.filters.length > 0 ) || (quickFilters && quickFilters.length > 0)) ? (
      <PresetFiltersComponent
        analytics={analytics}
        quickFilters={quickFilters}
        savedFilters={savedFilters}
        events={events}
        applied={applied}
        i18n={this.props.i18n}
      />
    ) : (<div />)
  }
}

export default PresetFiltersContainer
